import React from "react";
import submit from "submit-form";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import Select from "../parts/inputs/select";

function View(props, { locals }) {
  const [whatDescribesYou, setwhatDescribesYou] = React.useState(
    "I am not signing up now, but will definitely in the future"
  );
  const handleReturnButton = (e) => {
    e?.preventDefault?.();
    submit("coach-billing", {
      method: "GET",
    });
  };

  return (
    <LoginWrapper
      mainClass="Billing feedback"
      left={
        <form
          method="POST"
          action="/actions/user/user-denied-signup"
          data-noreset
        >
          <BackArrowButton
            onBack={(e) => handleReturnButton(e)}
            text=""
            classNames="mobile-hidden"
          />

          <section className="mobile-hidden">
            <h2 className="clipped w-fit ml-auto mr-auto">Feedback</h2>
            <p className="text-center mt-3">
              Thanks so much for giving MyStrengthBook a try. We're sorry that
              you didn't love it. Help us improve the software by filling out
              the survey below.
            </p>
          </section>

          <header className="only-show-mobile">
            <section>
              <BackArrowButton onBack={(_) => handleReturnButton()} />

              <h2 className="clipped text-center">Feedback</h2>
            </section>
            <p className="text-center mt-3">
              Thanks so much for giving MyStrengthBook a try. We're sorry that
              you didn't love it. Help us improve the software by filling out
              the survey below.
            </p>
          </header>

          <section>
            <label htmlFor="whatDescribesYou">What best describes you?</label>
            <Select
              name="whatDescribesYou"
              value={whatDescribesYou}
              onChange={setwhatDescribesYou}
              options={[
                {
                  value:
                    "I am not signing up now, but will definitely in the future",
                  label:
                    "I am not signing up now, but will definitely in the future",
                },
                {
                  value: "I am not signing up now, but may try in the future",
                  label: "I am not signing up now, but may try in the future",
                },
                {
                  value: "I am never signing up",
                  label: "I am never signing up",
                },
              ]}
            />

            <div className="checkboxes-wrapper">
              <div className="feedback-checkboxes">
                <label htmlFor="whyNotSignup">What made you not sign-up?</label>
                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Too expensive"
                  />
                  <span className="text">Too expensive</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Too buggy"
                  />
                  <span className="text">Too buggy</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Too confusing to use/learn "
                  />
                  <span className="text">Too confusing to use/learn</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Doesnt have the features I needwat"
                  />
                  <span className="text">
                    Doesn't have the features I need/want
                  </span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Not as good as an alternative"
                  />
                  <span className="text">Not as good as an alternative </span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Did not work the way I expected"
                  />
                  <span className="text">Did not work the way I expected</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Other (please specify below)"
                  />
                  <span className="text">Other (please specify below)</span>
                </div>
              </div>

              <div className="feedback-input">
                <label htmlFor="details">Please provide more details</label>
                <textarea
                  name="details"
                  placeholder="Optional but very appreciated."
                ></textarea>
              </div>
            </div>
          </section>

          <footer>
            <button
              data-button-type="primary"
              sz="large"
              className="px-10 !w-1/2 mobile-hidden"
              type="submit"
            >
              Continue
            </button>
            <button
              data-button-type="primary"
              sz="large"
              className="only-show-mobile"
              type="submit"
            >
              Continue
            </button>
          </footer>
        </form>
      }
    />
  );
}

const Feedback = (app) => {
  app.get("/feedback", ({ res }) => (res.body = <View />));
};

export default Feedback;
